
export const data = [
  {"id":"6694152",
  "value":"IT",
  "function":"IT",
  "title":"IT - Software Engineer ",
  "locations":"Pune",
  "minimumExperience":{"years":2},
  "maximumExperience":{"years":5},
  "updatedAt":"3 days ago",
  "industries":["IT/Computers - Software"],
  "functions":["IT","IT/Software Development - Application Programming/Maintenance"],
  "roles":["Software Engineer/Programmer"],
  "summary":"call or whatsapp on 9205521238",
  "jobTypes":[],
  "employmentTypes":["Full time"],
  "skills":"Senior software engineer Programmer Developer IT Software programmer",
  "recruiterId":771426,
  "companyId":489956,
  "designations":["Software Engineer/Programmer"],
  "maximumSalaryINRFilter":4530000,
  "minimumSalaryINRFilter":4050000,
  "minimumExperienceFilter":2,
  "maximumExperienceFilter":5,
  "employerTypes":["Company"],
  "companyName":"Infinix Immigration Service Private Limited",
  "companyProfile":"Infinix Immigration Service pvt. ltd. is Delhi’s most eminent Visa Consultant in Delhi. It was laid with an idea that was incepted in the minds of our founding members in the year 2016 believing that they had the potential to become one of the most successful businesses in future. We believe in providing top-notch services to our clients. We deal in business visa,retirement visa,skilled visa,citizenship visa,permanent residency,spouse marriage visa,sponsorship visa and much more. Our team of skilled & professional visa immigration consultants in Delhi are the face of our organization and experts in their field. Our aim is to provide dedicated and in time services to our clients.",
  "minimumSalaryFilter":4050000,
  "maximumSalaryFilter":4530000,
  "exp":"0 - 1 Years",
  "salary":"1-2Lakhs"
  },
  
  {"id":"6031603",
    "value": "IT/Software Development",
    "function" : "IT/Software Development",
  "jobId":6031603,
  "title":"IT/Software Development/Programmer Required For Canada & Australia",
  "locations":"Hydrabad",
  "minimumExperience":{"years":2},
  "maximumExperience":{"years":7},
  "updatedAt":"7 days ago",
  "industries":["IT/Computers - Software"],
  "functions":["IT/Software Development - QA & Testing",
  "IT/Software Development - System Programming"],
  "roles":["Project Management","Software Developer","System Administrator","System Analyst"],
  "summary":"research,design and write new software programs and computer operating systems. evaluate the software and systems that make computers and hardware work. develop existing programs by analyzing and identifying areas for modification.",
  "jobTypes":[],
  "qualifications":["Bachelor Of Technology (B.Tech/B.E)","Bachelor of Science (B.Sc)","Master in Computer Application (M.C.A)"],
  "employmentTypes":["Full time"],
  "skills":"Software Analyst,Software Engineer,Software Developer,Software Programmer",
  "recruiterId":878978,
  "companyId":584814,
  "designations":["Project Management","Software Developer","System Administrator","System Analyst"],
  "maximumSalaryINRFilter":4000000,
  "minimumSalaryINRFilter":3000000,
  "minimumExperienceFilter":2,
  "maximumExperienceFilter":7,
  "employerTypes":["Company"],
  "companyName":"Arcade Visas Services Private Limited",
  "companyProfile":"AVS IMMIGRATION is a company incorporated in INDIA and managed by a team of qualified and highly skilled professionals comprising efficient migration consultants,lawyers and Counselors with extensive resources and expertise at their disposal working.",
  "exp":"0 - 1 Years",
  "salary":"1-2Lakhs"
  },
  
  {"id":"6715648",
  "jobId":6715648,
    "value": "IT",
    "function" : "IT",
  "title":"IT - MDM Admin",
  "locations":"Hydrabad",
  "minimumExperience":{"years":4},
  "maximumExperience":{"years":6},
  "updatedAt":"2 hours ago",
  "industries":["IT/Computers - Software"],
  "functions":["IT"],
  "roles":["Software Engineer/Programmer"],
  "summary":"Oracle MDM (Meter Data Management)",
  "jobTypes":[],
  "employmentTypes":["Full time"],
  "skills":"Oracle MDM (Meter Data Management)  Admin",
  "recruiterId":505851,
  "companyId":804,
  "designations":["Software Engineer/Programmer"],
  "minimumExperienceFilter":4,
  "maximumExperienceFilter":6,
  "employerTypes":["Company"],
  "companyName":"Larsen & Toubro Infotech Limited",
  "companyProfile":"LTI (NSE: LTI) is a global technology consulting and digital solutions Company helping more than 485 clients succeed in a converging world. With operations in 33 countries,we go the extra mile for our clients and accelerate their digital transformation journeys. Founded in 1997 as a subsidiary of Larsen & Toubro Limited,our unique heritage gives us unrivalled real-world expertise to solve the most complex challenges of enterprises across all industries. Each day,our team of more than 45000 LTItes enable our clients to improve the effectiveness of their business and technology operations and deliver value to their customers,employees and shareholders.",
  "exp":"1 - 2 Years",
  "salary":"1-2Lakhs"
  },
  
  {"id":"6715642",
    "value":"Software Engineer",
    "function":"IT/Hardware/Teleco...",
  "jobId":6715642,
  "title":"Software Engineer - OUAF Developer ",
  "locations":"Bangalore",
  "minimumExperience":{"years":3},
  "maximumExperience":{"years":8},
  "updatedAt":"2 hours ago",
  "industries":["IT/Computers - Software"],
  "functions":["IT"],
  "roles":["Software Engineer/Programmer"],
  "summary":"MDM Utilities",
  "jobTypes":[],
  "employmentTypes":["Full time"],
  "skills":"MDM areas of VEE Rules,Usage Management,Device,Device Management",
  "recruiterId":505851,
  "companyId":804,
  "designations":["Software Engineer/Programmer"],
  "minimumExperienceFilter":3,
  "maximumExperienceFilter":8,
  "employerTypes":["Company"],
  "companyName":"Larsen & Toubro Infotech Limited",
  "companyProfile":"LTI (NSE: LTI) is a global technology consulting and digital solutions Company helping more than 485 clients succeed in a converging world. With operations in 33 countries,we go the extra mile for our clients and accelerate their digital transformation journeys. Founded in 1997 as a subsidiary of Larsen & Toubro Limited,our unique heritage gives us unrivalled real-world expertise to solve the most complex challenges of enterprises across all industries. Each day, our team of more than 45,000 LTItes enable our clients to improve the effectiveness of their business and technology operations and deliver value to their customers,employees and shareholders",
  "exp":"1 - 2 Years",
  "salary":"2-5Lakhs"
  },
  
  {"id":"6715611",
  "jobId":6715611,
    "value": "Software Engineer",
    "function" : "Manufacturing",
  "title":"HCL Technologies is hiring Software Engineer For its R&D group ",
  "locations":"Chennai",
  "minimumExperience":{"years":5},
  "maximumExperience":{"years":13},
  "updatedAt":"2 hours ago",
  "industries":["IT/Computers - Software"],
  "functions":["IT"],
  "roles":["Software Engineer/Programmer"],
  "summary":"Java ,Microservices ,Docker , Kubernetes .",
   "jobTypes":[],
   "employmentTypes":["Full time"],
   "recruiterId":903355,
   "companyId":462626,
   "designations":["Software Engineer/Programmer"],
   "minimumExperienceFilter":5,
   "maximumExperienceFilter":13,
   "employerTypes":["Company"],
   "companyName":"HCL Technologies Limited",
   "companyProfile":"HCL Technology ,Chennai",
   "skills":"Java,Microservices,Micro Services",
   "exp":"2 - 3 Years",
  "salary":"2-5Lakhs"
  },
  
   {"id":"6715574",
    "value":"Software Engineer",
    "function":"IT/Hardware/Teleco...",
   "jobId":6715574,
   "title":"Software Engineer : React native Developer - Atos",
   "locations":"Chennai",
   "minimumExperience":{"years":5},
   "maximumExperience":{"years":8},
   "updatedAt":"3 hours ago",
   "industries":["IT/Computers - Software"],
   "functions":["IT"],
   "roles":["Software Engineer/Programmer"],
  "summary":"Hiring React Native developer for our project in Chennai / Pune ,/Mumbai. Interested please apply",
   "jobTypes":[],
   "employmentTypes":["Full time"],
   "recruiterId":872340,
   "companyId":545324,
   "designations":["Software Engineer/Programmer"],
   "minimumExperienceFilter":5,
   "maximumExperienceFilter":8,
   "employerTypes":["Company"],
   "companyName":"Atos Global It Solutions And Services Private Limited",
   "companyProfile":"| Worldwide Digital Leader | 11 billion revenue | 111,000 Employees | 71 Countries | Olympic & Paralympic Games Worldwide Partner |<br> <br> Atos is a global leader in digital transformation with 111,000 employees and annual revenue of c. € 11 billion. European number one in cybersecurity,cloud and high performance computing,the Group provides tailored end-to-end solutions for all industries in 71 countries. <br> <br> A pioneer in decarbonization services and products,Atos is committed to a secure and decarbonized digital for its clients. Atos is a SE (Societas Europaea),listed on Euronext Paris and included in the CAC 40 ESG and Next 20 Paris Stock indexes.",
   "skills":"React Native,Reactjs,ui,Redux,Ios,Android,Xcode,Intellij,Mobile Developer",
   "exp":"3 - 4 Years",
  "salary":"2-5Lakhs"
  },
  
   {"id":"6715570",
    "value": "Software Engineer",
   "jobId":6715570,
   "title":"Software Engineer with LTI - Larsen & Toubro Infotech",
   "locations":"Bangalore",
   "minimumExperience":{"years":4},
   "maximumExperience":{"years":9},
   "updatedAt":"3 hours ago",
   "industries":["IT/Computers - Software"],
   "functions":["IT"],
   "roles":["Software Engineer/Programmer"],
   "summary":"Informatica ETL development ,PL/SQL,Strong familiarity of data warehouse projects and Data Modeling,Data Architect.",
   "jobTypes":[],
   "employmentTypes":["Full time"],
   "skills":"Informatica Developer,Etl Informatica,Etl,Informatica",
   "recruiterId":589310,
   "companyId":804,
   "designations":["Software Engineer/Programmer"],
   "minimumExperienceFilter":4,
   "maximumExperienceFilter":9,
   "employerTypes":["Company"],
   "companyName":"Larsen & Toubro Infotech Limited",
   "companyProfile":"LTI (NSE: LTI) is a global technology consulting and digital solutions Company helping more than 485 clients succeed in a converging world. With operations in 33 countries,we go the extra mile for our clients and accelerate their digital transformation journeys. Founded in 1997 as a subsidiary of Larsen & Toubro Limited,our unique heritage gives us unrivalled real-world expertise to solve the most complex challenges of enterprises across all industries. Each day,our team of more than 45,000 LTItes enable our clients to improve the effectiveness of their business and technology operations and deliver value to their customers,employees and shareholders.",
   "exp":"3 - 4 Years",
  "salary":"2-5Lakhs"
  },
  
   {"id":"6715561",
    "value": "IT/Hardware/Telecommunication",
   "jobId":6715561,
   "title":"IBM - IT/Hardware/Telecommunication",
   "locations":"Bangalore",
   "minimumExperience":{"years":4},
   "maximumExperience":{"years":10},
   "updatedAt":"3 hours ago",
   "industries":["IT/Computers - Software"],
   "functions":["IT"],
   "roles":["Software Engineer/Programmer"],
   "summary":"Urgent hiring_IBM - Data stage_Tata Consultancy Services(TCS)\r \r Skills- Data stage IBM MB Developer\r EXP- 5-15 Years\r  Job locations- PAN India\r ",
   "jobTypes":[],
   "qualifications":["Bachelor of Business Administration (B.B.A)","Bachelor Of Computer Application (B.C.A)","Bachelor Of Technology (B.Tech/B.E)","Master in Computer Application (M.C.A)","Masters in Technology (M.Tech/M.E/M.Sc)"],
   "employmentTypes":["Full time"],
   "recruiterId":561797,
   "companyId":1161,
   "designations":["Software Engineer/Programmer"],
   "minimumExperienceFilter":4,
   "maximumExperienceFilter":10,
   "employerTypes":["Company"],
   "companyName":"TATA Consultancy Services Ltd.",
   "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 of the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31,2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
   "skills":"Ibm Mq,DataStage",
   "exp":"3 - 4 Years",
  "salary":"2-5Lakhs"
  },
  
   {"id":"6715559",
  
  "value": "IT Application Designer Specialist",
   "jobId":6715559,
   "title":"IT Application Designer Specialist_Tata Consultancy Services(TCS)",
  "locations":"Pune",
   "minimumExperience":{"years":4},
   "maximumExperience":{"years":11},
   "updatedAt":"3 hours ago",
   "industries":["IT/Computers - Software"],
   "functions":["IT"],
   "roles":["Software Engineer/Programmer"],
   "summary":"Urgent hiring_  Spark Developer  ( Scala or python)_Tata Consultancy Services(TCS)\r \r Skills- Spark Developer  ( Scala or python)\r EXP-4-8 Years\r  Job locations-Kolkata |Hyderabad|Ahmedabad | Chennai | Delhi\r ",
   "jobTypes":[],
   "qualifications":["Bachelor Of Computer Application (B.C.A)",
   "Bachelor Of Technology (B.Tech/B.E)",
   "Master OF Business Administration (M.B.A)",
   "Master in Computer Application (M.C.A)",
   "Masters in Technology (M.Tech/M.E/M.Sc)"],
   "employmentTypes":["Full time"],
   "recruiterId":561797,
   "companyId":1161,
   "designations":["Software Engineer/Programmer"],
   "minimumExperienceFilter":4,
   "maximumExperienceFilter":11,
   "employerTypes":["Company"],
   "companyName":"TATA Consultancy Services Ltd.",
   "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 of the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31,2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
   "skills":"Spark",
  "salary":"2-5Lakhs",
  "exp":"3 - 4 Years",
  },
  
   {"id":"6715558",
    "value": "IT Application Designer Specialist",
   "jobId":6715558,
   "title":"IT Application Designer Specialist _Tata Consultancy Services(TCS)",
   "locations":"Bangalore",
   "minimumExperience":{"years":5},
   "maximumExperience":{"years":15},
   "updatedAt":"3 hours ago",
   "industries":["IT/Computers - Software"],
   "functions":["IT"],
   "roles":["Software Engineer/Programmer"],
  "summary":"Urgent hiring_Data scientist _Tata Consultancy Services(TCS),Skills-DatascientistEXP-YearsJoblocations- PAN India | Delhi NCR/Indore/ Kochi/ Bangalore / Mumbai / Pune",
   "jobTypes":[],
   "qualifications":["Bachelor Of Computer Application (B.C.A)","Bachelor Of Technology (B.Tech/B.E)","Master in Business Administration (M.B.A","Master in Computer Application (M.C.A)","Masters in Technology (M.Tech/M.E/M.Sc)"],
   "employmentTypes":["Full time"],
   "recruiterId":561797,
   "companyId":1161,
   "designations":["Software Engineer/Programmer"],
   "minimumExperienceFilter":5,
   "maximumExperienceFilter":15,
   "employerTypes":["Company"],
   "companyName":"TATA Consultancy Services Ltd.",
   "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 of the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31, 2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
   "skills":"Data Scientist,Data Science",
  "salary":"2-5Lakhs",
  "exp":"3 - 4 Years",
   },
  
  
   {"id":"6715553",
    "value":"Application Engineer",
    "function":"IT/Hardware/Teleco...",
   "jobId":6715553,
   "title":"Application Engineer_Tata Consultancy Services(TCS)",
  "locations":"Pune",
   "minimumExperience":{"years":4},
   "maximumExperience":{"years":10},
   "updatedAt":"3 hours ago",
   "industries":["IT/Computers - Software"],
   "functions":["IT"],
   "roles":["Software Engineer/Programmer"],
   "summary":"Urgent hiring_Spark_Tata Consultancy Services(TCS)\r \r Skills- Spark Data Architect / ( SPARK,PYSPARK ,SCALA,PYTHON)\r EXP-  4-12 Years\r  Job locations-  Ahmedabad/  Hyderabad/ Chennai / Kolkata\r ",
   "jobTypes":[],
   "qualifications":["Bachelor of Business Administration (B.B.A)",
   "Bachelor Of Computer Application (B.C.A)",
   "Bachelor Of Technology (B.Tech/B.E)",
   "Master OF Business Administration (M.B.A)",
   "Master in Computer Application (M.C.A)",
   "Masters in Technology (M.Tech/M.E/M.Sc)"],
   "employmentTypes":["Full time"],
   "recruiterId":561797,
   "companyId":1161,
   "designations":["Software Engineer/Programmer"],
   "minimumExperienceFilter":4,
   "maximumExperienceFilter":10,
   "employerTypes":["Company"],
   "companyName":"TATA Consultancy Services Ltd.",
   "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 of the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31,2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
   "skills":"Data Scientist,Data Science",
  "salary":"5-10Lakhs",
  "exp":"3 - 4 Years",
   },
  
   {"id":"6715554",
   "jobId":6715554,
    "value": "IT/Software Development",
    "function" : "IT/Software Development", 
   "title":"IT/Software Development_Tata Consultancy Services(TCS)",
   "locations":"Bangalore",
   "minimumExperience":{"years":4},
   "maximumExperience":{"years":10},
   "updatedAt":"3 hours ago",
   "industries":["IT/Computers - Software"],
   "functions":["IT"],
   "roles":["Software Engineer/Programmer"],
   "summary":"Urgent hiring_Tableau Admin_Tata Consultancy Services(TCS) Skills- Tableau Admin EXP- 3-10 Years Job locations-  Bangalore/  Kolkata  / Hyderabad/ Chennai ",
   "jobTypes":[],
   "qualifications":["Bachelor Of Computer Application (B.C.A)",
   "Master OF Business Administration (M.B.A)",
   "Master in Computer Application (M.C.A)",
   "Masters in Technology (M.Tech/M.E/M.Sc)"],
   "employmentTypes":["Full time"],
   "recruiterId":561797,
   "companyId":1161,
   "designations":["Software Engineer/Programmer"],
   "minimumExperienceFilter":4,
   "maximumExperienceFilter":10,
   "employerTypes":["Company"],
   "companyName":"TATA Consultancy Services Ltd.",
   "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 of the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31,2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
   "skills":"Data Scientist,Data Science",
   "exp":"3 - 4 Years",
  "salary":"5-10Lakhs"
  },
  
   {"id":"6715550",
    "value": "Manufacturing",
    "jobId":6715550,
    "title":"Manufacturing_Tata Consultancy Services(TCS)",
    "locations":"Pune",
    "minimumExperience":{"years":4},
    "maximumExperience":{"years":10},
    "updatedAt":"3 hours ago",
    "industries":["IT/Computers - Software"],
    "functions":["IT"],
    "roles":["Software Engineer/Programmer"],
  "summary":"Urgent hiring_  Python,Data science_Tata Consultancy Services(TCS)\r \r Skills-  Python,Data science\r EXP-4-8 Years\r  Job locations-  Mumbai |Delhi / Pune\r ",
    "jobTypes":[],
    "qualifications":["Bachelor Of Computer Application (B.C.A)","Bachelor Of Technology (B.Tech/B.E)","Master Of Business Administration (M.B.A)","Master in Computer Application (M.C.A)","Masters in Technology (M.Tech/M.E/M.Sc)"],
    "employmentTypes":["Full time"],
    "recruiterId":561797,
    "companyId":1161,
    "designations":["Software Engineer/Programmer"],
    "minimumExperienceFilter":4,
    "maximumExperienceFilter":10,
    "companyName":"TATA Consultancy Services Ltd.",
    "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 over the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31,2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
    "skills":"Data Scientist,Data Science",
    "exp":"3 - 4 Years",
    "salary":"5-10Lakhs"
      },
  
      {"id":"6715585",
        "value":"Software Engineer",
        "function":"IT/Hardware/Teleco...",
    "jobId":6715550,
    "title":"Software Engineer_Tata Consultancy Services(TCS)",
  "locations":"Pune",
    "minimumExperience":{"years":4},
    "maximumExperience":{"years":10},
    "updatedAt":"3 hours ago",
    "industries":["IT/Computers - Software"],
    "functions":["IT"],
    "roles":["Software Engineer/Programmer"],
  "summary":"Urgent hiring_  Python,Data science_Tata Consultancy Services(TCS)\r \r Skills-  Python,Data science\r EXP-4-8 Years\r  Job locations-  Mumbai |Delhi / Pune\r ",
    "jobTypes":[],
    "qualifications":["Bachelor Of Computer Application (B.C.A)","Bachelor Of Technology (B.Tech/B.E)","Master Of Business Administration (M.B.A)","Master in Computer Application (M.C.A)","Masters in Technology (M.Tech/M.E/M.Sc)"],
    "employmentTypes":["Full time"],
    "recruiterId":561797,
    "companyId":1161,
    "designations":["Software Engineer/Programmer"],
    "minimumExperienceFilter":4,
    "maximumExperienceFilter":10,
    "companyName":"TATA Consultancy Services Ltd.",
    "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 over the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31,2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
    "skills":"Data Scientist,Data Science",
    "exp":"3 - 4 Years",
    "salary":"0-1Lakhs"
      },
  
      {"id":"6031606",
        "value":"IT",
        "function":"IT/Hardware/Teleco...",
  "jobId":6031603,
  "title":" IT - Software Engineer/Programmer Required ",
  "locations":"Bangalore",
  "minimumExperience":{"years":2},
  "maximumExperience":{"years":7},
  "updatedAt":"7 days ago",
  "industries":["IT/Computers - Software"],
  "functions":["IT/Software Development - QA & Testing",
  "IT/Software Development - System Programming"],
  "roles":["Project Management","Software Developer","System Administrator","System Analyst"],
  "summary":"research,design and write new software programs and computer operating systems. evaluate the software and systems that make computers and hardware work. develop existing programs by analyzing and identifying areas for modification.",
  "jobTypes":[],
  "qualifications":["Bachelor Of Technology (B.Tech/B.E)","Bachelor of Science (B.Sc)","Master in Computer Application (M.C.A)"],
  "employmentTypes":["Full time"],
  "skills":"Software Analyst,Software Engineer,Software Developer,Software Programmer",
  "recruiterId":878978,
  "companyId":584814,
  "designations":["Project Management","Software Developer","System Administrator","System Analyst"],
  "maximumSalaryINRFilter":4000000,
  "minimumSalaryINRFilter":3000000,
  "minimumExperienceFilter":2,
  "maximumExperienceFilter":7,
  "employerTypes":["Company"],
  "companyName":"Arcade Visas Services Private Limited",
  "companyProfile":"AVS IMMIGRATION is a company incorporated in INDIA and managed by a team of qualified and highly skilled professionals comprising efficient migration consultants,lawyers and Counselors with extensive resources and expertise at their disposal working.",
  "exp":"0 - 1 Years",
  "salary":"0-1Lakhs"
      },
  
      {"id":"67156112",
  "jobId":6715642,
        "value": "IT",
        "function" : "IT/Software Development",
  "title":"IT - OUAF Developer ",
  "locations":"Bangalore",
  "minimumExperience":{"years":3},
  "maximumExperience":{"years":8},
  "updatedAt":"2 hours ago",
  "industries":["IT/Computers - Software"],
  "functions":["IT"],
  "roles":["Software Engineer/Programmer"],
  "summary":"MDM Utilities",
  "jobTypes":[],
  "employmentTypes":["Full time"],
  "skills":"MDM areas of VEE Rules,Usage Management,Device,Device Management",
  "recruiterId":505851,
  "companyId":804,
  "designations":["Software Engineer/Programmer"],
  "minimumExperienceFilter":3,
  "maximumExperienceFilter":8,
  "employerTypes":["Company"],
  "companyName":"Larsen & Toubro Infotech Limited",
  "companyProfile":"LTI (NSE: LTI) is a global technology consulting and digital solutions Company helping more than 485 clients succeed in a converging world. With operations in 33 countries,we go the extra mile for our clients and accelerate their digital transformation journeys. Founded in 1997 as a subsidiary of Larsen & Toubro Limited,our unique heritage gives us unrivalled real-world expertise to solve the most complex challenges of enterprises across all industries. Each day, our team of more than 45,000 LTItes enable our clients to improve the effectiveness of their business and technology operations and deliver value to their customers,employees and shareholders",
  "exp":"2 - 3 Years",
  "salary":"0-1Lakhs"
      },
  
        {"id":"6715584",
          "value":"Software Engineer",
          "function":"IT/Hardware/Teleco...",
        "jobId":6715554,
        "title":"Software Engineer_Tata Consultancy Services(TCS)",
        "locations":"Bangalore",
        "minimumExperience":{"years":4},
        "maximumExperience":{"years":10},
        "updatedAt":"3 hours ago",
        "industries":["IT/Computers - Software"],
        "functions":["IT"],
        "roles":["Software Engineer/Programmer"],
        "summary":"Urgent hiring_Tableau Admin_Tata Consultancy Services(TCS) Skills- Tableau Admin EXP- 3-10 Years Job locations-  Bangalore/  Kolkata  / Hyderabad/ Chennai ",
        "jobTypes":[],
        "qualifications":["Bachelor Of Computer Application (B.C.A)",
        "Master OF Business Administration (M.B.A)",
        "Master in Computer Application (M.C.A)",
        "Masters in Technology (M.Tech/M.E/M.Sc)"],
        "employmentTypes":["Full time"],
        "recruiterId":561797,
        "companyId":1161,
        "designations":["Software Engineer/Programmer"],
        "minimumExperienceFilter":4,
        "maximumExperienceFilter":10,
        "employerTypes":["Company"],
        "companyName":"TATA Consultancy Services Ltd.",
        "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 of the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31,2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
        "skills":"Data Scientist,Data Science",
      
        "exp":"0 - 1 Years",
        "salary":"0-1Lakhs"
        },
  
        {"id":"6031113",
          "value": "Solution Architect/Enterprise Architect",
  "jobId":6031603,
  "title":"Solution Architect/Enterprise Architect Required",
  "locations":"Bangalore",
  "minimumExperience":{"years":2},
  "maximumExperience":{"years":7},
  "updatedAt":"7 days ago",
  "industries":["IT/Computers - Software"],
  "functions":["IT/Software Development - QA & Testing",
  "IT/Software Development - System Programming"],
  "roles":["Project Management","Software Developer","System Administrator","System Analyst"],
  "summary":"research,design and write new software programs and computer operating systems. evaluate the software and systems that make computers and hardware work. develop existing programs by analyzing and identifying areas for modification.",
  "jobTypes":[],
  "qualifications":["Bachelor Of Technology (B.Tech/B.E)","Bachelor of Science (B.Sc)","Master in Computer Application (M.C.A)"],
  "employmentTypes":["Full time"],
  "skills":"Software Analyst,Software Engineer,Software Developer,Software Programmer",
  "recruiterId":878978,
  "companyId":584814,
  "designations":["Project Management","Software Developer","System Administrator","System Analyst"],
  "maximumSalaryINRFilter":4000000,
  "minimumSalaryINRFilter":3000000,
  "minimumExperienceFilter":2,
  "maximumExperienceFilter":7,
  "employerTypes":["Company"],
  "companyName":"Arcade Visas Services Private Limited",
  "companyProfile":"AVS IMMIGRATION is a company incorporated in INDIA and managed by a team of qualified and highly skilled professionals comprising efficient migration consultants,lawyers and Counselors with extensive resources and expertise at their disposal working.",
  "exp":"0 - 1 Years",
  "salary":"1-2Lakhs"
        },
  
        {"id":"6715577",
          "value": "IT/Hardware/Telecommunication",
        "jobId":6715570,
        "title":"Urgent hiring for IT/Hardware/Telecommunication",
        "locations":"Bangalore",
        "minimumExperience":{"years":4},
        "maximumExperience":{"years":9},
        "updatedAt":"3 hours ago",
        "industries":["IT/Computers - Software"],
        "functions":["IT"],
        "roles":["Software Engineer/Programmer"],
        "summary":"Informatica ETL development ,PL/SQL,Strong familiarity of data warehouse projects and Data Modeling,Data Architect.",
        "jobTypes":[],
        "employmentTypes":["Full time"],
        "skills":"Informatica Developer,Etl Informatica,Etl,Informatica",
        "recruiterId":589310,
        "companyId":804,
        "designations":["Software Engineer/Programmer"],
        "minimumExperienceFilter":4,
        "maximumExperienceFilter":9,
        "employerTypes":["Company"],
        "companyName":"Larsen & Toubro Infotech Limited",
        "companyProfile":"LTI (NSE: LTI) is a global technology consulting and digital solutions Company helping more than 485 clients succeed in a converging world. With operations in 33 countries,we go the extra mile for our clients and accelerate their digital transformation journeys. Founded in 1997 as a subsidiary of Larsen & Toubro Limited,our unique heritage gives us unrivalled real-world expertise to solve the most complex challenges of enterprises across all industries. Each day,our team of more than 45,000 LTItes enable our clients to improve the effectiveness of their business and technology operations and deliver value to their customers,employees and shareholders.",
      
        "exp":"0 - 1 Years",
       "salary":"1-2Lakhs"
       },
  
       {"id":"6715666",
       "jobId":6715561,
        "value": "IT",
        "function" : "IT/Software Development", 
       "title":"IT - Data stage_Tata Consultancy Services(TCS)",
       "locations":"Hydrabad",
       "minimumExperience":{"years":4},
       "maximumExperience":{"years":10},
       "updatedAt":"3 hours ago",
       "industries":["IT/Computers - Software"],
       "functions":["IT"],
       "roles":["Software Engineer/Programmer"],
       "summary":"Urgent hiring_IBM - Data stage_Tata Consultancy Services(TCS)\r \r Skills- Data stage IBM MB Developer\r EXP- 5-15 Years\r  Job locations- PAN India\r ",
       "jobTypes":[],
       "qualifications":["Bachelor of Business Administration (B.B.A)","Bachelor Of Computer Application (B.C.A)","Bachelor Of Technology (B.Tech/B.E)","Master in Computer Application (M.C.A)","Masters in Technology (M.Tech/M.E/M.Sc)"],
       "employmentTypes":["Full time"],
       "recruiterId":561797,
       "companyId":1161,
       "designations":["Software Engineer/Programmer"],
       "minimumExperienceFilter":4,
       "maximumExperienceFilter":10,
       "employerTypes":["Company"],
       "companyName":"TATA Consultancy Services Ltd.",
       "companyProfile":"A part of the Tata group,India's largest multinational business group,TCS has over 500,000 of the world’s best-trained consultants in 46 countries. The company generated consolidated revenues of US $22.2 billion in the fiscal year ended March 31,2021,and is listed on the BSE (formerly Bombay Stock Exchange) and the NSE (National Stock Exchange) in India. TCS' proactive stance on climate change and award-winning work with communities across the world have earned it a place in leading sustainability indices such as the MSCI Global Sustainability Index and the FTSE4Good Emerging Index.",
       "skills":"Ibm Mq,DataStage",
    
       "exp":"0 - 1 Years",
      "salary":"1-2Lakhs"
      }
    ]
